import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {CountryModel} from '../../../api/entity/country.model';



@Injectable({providedIn: 'root'})
export class CountryRepository extends AbstractRepositoryV2<CountryModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Country', serviceElementsFactory, injector);
    }
}
